/* ==========================================================================
   WORKUID POP-UP — vitrin betiği
   Uygulama: Workuid Pop-up (C:\workuid-popup, app.takdig.com/popup).

   Yayındaki pop-up'lar mağaza meta alanından gelir (snippets/workuid-popup:
   <script id="workuid-popup-veri">). Bu betik:
     1. kurallara uyan İLK pop-up'ı seçer (öncelik sırası sunucuda verildi):
        tarih · üye/misafir · abone · cihaz · sayfa türü · adres · sıklık
     2. tetikleyiciyi bekler (süre / kaydırma / sayfadan çıkış)
     3. çizer, açar, olayları sayar (App Proxy → /apps/popup/olay)
     4. formu Shopify'ın e-bülten kaydına gönderir — footer'daki E-BÜLTEN ile
        aynı kayıt (form_type=customer, contact[tags]) ve aynı robot koruması
        (Shopify'ın görünmez hCaptcha'sı) — başarıda formun yerine
        "İNDİRİMİ KAZANDINIZ", buton "ALIŞVERİŞE DEVAM ET". Önce sayfa
        yenilemeden denenir; Cloudflare izin vermezse sayfa geçişiyle
        gönderilir ve pop-up dönüşte "kazandınız" hâliyle açılır.

   SIKLIK: gösterildiği AN işaretlenir (kapatılınca değil) ve işaret bütün
   sitede geçerlidir — bir sayfada gören, başka sayfada yeniden görmez.
   localStorage; tarayıcı izin vermezse çerez.

   Yönetim ekranındaki canlı önizleme bu dosyanın AYNISINI kullanır
   (window.WORKUID_POPUP_ONIZLEME) — tek çizim kodu, iki yerde aynı görünüm.
   ========================================================================== */
(() => {
  'use strict';

  if (window.WorkuidPopup) return;

  const B = window.WORKUID_POPUP || {};
  const ONIZLEME_CERCEVESI = !!window.WORKUID_POPUP_ONIZLEME;
  const MOBIL = '(max-width: 749px)';
  const ON = 'wpop:';

  /* ── Depolama ─────────────────────────────────────────────────────── */
  function cerez(ad) {
    const m = document.cookie.match(new RegExp('(?:^|;\\s*)' + ad + '=([^;]*)'));
    return m ? decodeURIComponent(m[1]) : null;
  }

  function al(k) {
    try {
      const v = localStorage.getItem(ON + k);
      if (v !== null) return v;
    } catch (e) { /* gizli sekme vb. */ }
    return cerez('wpop_' + k);
  }

  function koy(k, v) {
    try {
      localStorage.setItem(ON + k, String(v));
      return;
    } catch (e) { /* çereze düş */ }
    document.cookie = 'wpop_' + k + '=' + encodeURIComponent(v) + ';path=/;max-age=31536000;SameSite=Lax';
  }

  function oturumAl(k) {
    try {
      return sessionStorage.getItem(ON + k);
    } catch (e) {
      return cerez('wpops_' + k);
    }
  }

  function oturumKoy(k, v) {
    try {
      if (v === null) sessionStorage.removeItem(ON + k);
      else sessionStorage.setItem(ON + k, String(v));
      return;
    } catch (e) { /* çereze düş */ }
    document.cookie = 'wpops_' + k + '=' + (v === null ? ';max-age=0' : encodeURIComponent(v)) + ';path=/;SameSite=Lax';
  }

  /* ── Yardımcılar ──────────────────────────────────────────────────── */
  const kacis = (s) => String(s == null ? '' : s).replace(/[&<>"']/g,
    (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]));

  /* Yalnız site içi yol ya da http(s) — javascript: vb. asla */
  const guvenliLink = (s) => (/^(\/(?!\/)|https?:\/\/)/i.test(String(s || '')) ? String(s) : '');

  const mobil = () => window.matchMedia(MOBIL).matches;
  const bekle = (ms) => new Promise((coz) => setTimeout(coz, ms));

  /* ₺ yazı tipimizde yok — tasarımda da sistem yazı tipinden, normal kalınlıkta */
  const tl = (s) => kacis(s).replace(/₺/g, '<span class="wpop__tl">₺</span>');

  function cdn(url, en) {
    return url + (url.indexOf('?') > -1 ? '&' : '?') + 'width=' + en;
  }

  function srcset(g) {
    const en = g.en || 2400;
    const adimlar = [400, 600, 800, 1000, 1200, 1600, 2000, 2400].filter((w) => w <= en);
    if (!adimlar.length) return g.url + ' ' + en + 'w';
    return adimlar.map((w) => cdn(g.url, w) + ' ' + w + 'w').join(', ');
  }

  /* ── Sayaç ────────────────────────────────────────────────────────── */
  function olay(p, ad) {
    if (!B.proxy || !p || !p.id) return;
    const adres = B.proxy + '/olay?p=' + p.id + '&o=' + ad + '&c=' + (mobil() ? 'm' : 'd') +
      '&s=' + encodeURIComponent(B.sayfa || '');
    try {
      if (navigator.sendBeacon && navigator.sendBeacon(adres)) return;
    } catch (e) { /* fetch'e düş */ }
    try {
      fetch(adres, { method: 'POST', keepalive: true, credentials: 'same-origin' }).catch(() => {});
    } catch (e) { /* sayaç kaybı pop-up'ı bozmasın */ }
  }

  /* ── Çizim ────────────────────────────────────────────────────────── */
  let sira = 0;

  function baslikHtml(i, kimlik) {
    const b = String(i.baslik_buyuk || '').trim();
    const k = String(i.baslik_kucuk || '').trim();
    if (!b && !k) return '';
    return '<h2 class="wpop__baslik" id="' + kimlik + '">' +
      (b ? '<span class="wpop__baslik-b">' + tl(b) + '</span>' : '') +
      (k ? '<span class="wpop__baslik-k">' + (b ? ' ' : '') + tl(k) + '</span>' : '') +
      '</h2>';
  }

  /* Form GERÇEK bir Shopify e-bülten formu (footer'daki E-BÜLTEN'in aynısı:
     action /contact, form_type=customer, contact[email], contact[tags]).
     Böylece Shopify'ın robot koruması (captcha-bootstrap → görünmez hCaptcha)
     bu formu da tanıyıp korur — korumasız kayıt Cloudflare'de 403'e düşüyor.
     Seçim ve onay kutusu contact[…] değil: Shopify'a ayrı alan olarak gitmez,
     seçimin etiketi gönderimde contact[tags]'e eklenir. */
  function formHtml(f, i, n) {
    const secenekler = (f.secenekler || []).filter((s) => s && s.ad);
    const etiket = (f.etiketler || []).join(', ');
    let h = '<form class="wpop__form" method="post" action="/contact#wpop" accept-charset="UTF-8" novalidate>' +
      '<input type="hidden" name="form_type" value="customer">' +
      '<input type="hidden" name="utf8" value="✓">' +
      '<input type="hidden" name="contact[tags]" value="' + kacis(etiket) + '">' +
      '<div class="wpop__alan">';
    if (secenekler.length) {
      h += '<fieldset class="wpop__secenekler"><legend class="wpop-gizli">Seçiminiz</legend>' +
        secenekler.map((s, k) =>
          '<label class="wpop__secenek"><input type="radio" name="wpop-secim" value="' + k + '"' +
          (f.secenek_zorunlu ? ' required' : '') + '><span>' + kacis(s.ad) + '</span></label>').join('') +
        '</fieldset>';
    }
    h += '<label class="wpop-gizli" for="' + n + '-e">E-posta adresi</label>' +
      '<input class="wpop__eposta" id="' + n + '-e" type="email" name="contact[email]" inputmode="email"' +
      ' autocomplete="email" autocapitalize="off" spellcheck="false" required' +
      ' placeholder="' + kacis(f.eposta_yer || '') + '">';
    if (f.onay_metni) {
      const ol = guvenliLink(f.onay_link);
      h += '<label class="wpop__onay"><input type="checkbox" data-wpop-onay' + (f.onay_zorunlu ? ' required' : '') + '>' +
        '<span>' + (ol ? '<a href="' + kacis(ol) + '" target="_blank" rel="noopener">' + kacis(f.onay_metni) + '</a>'
          : kacis(f.onay_metni)) + '</span></label>';
    }
    h += '<p class="wpop__hata" role="alert" hidden></p></div>';
    h += '<div class="wpop__basari" role="status" hidden>' +
      '<p class="wpop__basari-baslik">' + kacis(f.basari_baslik || '') + '</p>' +
      (f.basari_metin ? '<p class="wpop__basari-metin">' + tl(f.basari_metin) + '</p>' : '') +
      (f.indirim_kodu ? '<p class="wpop__kod"><span>' + kacis(f.indirim_kodu) + '</span>' +
        '<button type="button" data-wpop-kopyala>KOPYALA</button></p>' : '') +
      '</div>';
    h += '<button class="wpop__buton" type="submit">' + kacis(i.buton || '') + '</button></form>';
    return h;
  }

  function ciz(p, sec) {
    sec = sec || {};
    const i = p.icerik || {};
    const g = p.gorunum || {};
    const tur = p.tur;
    const f = (tur === 'form' || tur === 'gorsel_form') ? p.form : null;
    const gorselVar = /gorsel/.test(tur) && i.gorsel && i.gorsel.url;
    const metinli = tur !== 'gorsel';
    const konum = tur !== 'gorsel' && gorselVar ? (g.gorsel_konum || 'sol') : '';
    const n = 'wpop' + p.id + '-' + (++sira);
    const W = +g.genislik || 692;
    const oran = +g.gorsel_oran || 45;

    const d = document.createElement('dialog');
    d.className = 'wpop wpop--' + tur + (konum ? ' wpop--gorsel-' + konum : '') +
      (g.mobil_gorsel === 'gizle' ? ' wpop--mobil-gorsel-gizle' : '');
    d.setAttribute('data-wpop-id', p.id);
    d.tabIndex = -1;
    const stil = [
      '--wpop-w:' + W + 'px',
      '--wpop-ic:' + (konum === 'sol' || konum === 'sag' ? Math.round(W * (100 - oran) / 100) : W) + 'px',
      '--wpop-gorsel-oran:' + oran + '%',
      '--wpop-baslik-olcek:' + ((+i.baslik_olcek || 100) / 100),
    ];
    [['zemin', '--wpop-zemin'], ['metin', '--wpop-metin'], ['soluk', '--wpop-soluk'],
      ['buton_zemin', '--wpop-buton'], ['buton_metin', '--wpop-buton-metin']].forEach(([k, v]) => {
      if (/^#[0-9a-f]{6}$/i.test(g[k] || '')) stil.push(v + ':' + g[k]);
    });
    d.setAttribute('style', stil.join(';'));

    const baslikId = n + '-b';
    if (metinli && (i.baslik_buyuk || i.baslik_kucuk)) d.setAttribute('aria-labelledby', baslikId);
    else d.setAttribute('aria-label', i.gorsel_alt || i.ust_yazi || 'Kampanya');

    let gorsel = '';
    if (gorselVar) {
      const tamGenislik = tur === 'gorsel' || konum === 'ust';
      const goruntu = tamGenislik ? W : Math.round(W * oran / 100);
      const mob = i.gorsel_mobil && i.gorsel_mobil.url
        ? '<source media="' + MOBIL + '" srcset="' + kacis(srcset(i.gorsel_mobil)) + '" sizes="calc(100vw - 32px)">' : '';
      const img = '<picture>' + mob + '<img src="' + kacis(cdn(i.gorsel.url, 1200)) + '" srcset="' +
        kacis(srcset(i.gorsel)) + '" sizes="' + MOBIL + ' calc(100vw - 32px), ' + goruntu + 'px"' +
        (i.gorsel.en ? ' width="' + i.gorsel.en + '" height="' + i.gorsel.boy + '"' : '') +
        ' alt="' + kacis(i.gorsel_alt || '') + '" decoding="async"></picture>';
      const h = guvenliLink(i.gorsel_link);
      gorsel = '<div class="wpop__gorsel">' +
        (h ? '<a href="' + kacis(h) + '" data-wpop-tikla>' + img + '</a>' : img) + '</div>';
    }

    let ic = '';
    if (metinli) {
      if (i.ust_yazi) {
        ic += '<p class="wpop__ust' + (i.ust_nokta ? ' wpop__ust--nokta' : '') + '">' +
          (i.ust_nokta ? '<span>' + kacis(i.ust_yazi) + '</span>' : kacis(i.ust_yazi)) + '</p>';
      }
      ic += baslikHtml(i, baslikId);
      if (i.alt_yazi) ic += '<p class="wpop__alt">' + tl(i.alt_yazi) + '</p>';
      if (f) {
        ic += formHtml(f, i, n);
      } else if (i.buton) {
        const h = guvenliLink(i.buton_link);
        ic += h ? '<a class="wpop__buton" href="' + kacis(h) + '" data-wpop-tikla>' + kacis(i.buton) + '</a>'
          : '<button class="wpop__buton" type="button" data-wpop-tamam>' + kacis(i.buton) + '</button>';
      }
    }

    d.innerHTML = '<div class="wpop__kutu">' +
      '<button class="wpop__kapat" type="button" aria-label="Kapat" data-wpop-kapat>' +
      '<svg viewBox="0 0 24 24" aria-hidden="true" focusable="false"><path d="M5 5l14 14M19 5L5 19" ' +
      'fill="none" stroke="currentColor" stroke-width="1.6"/></svg></button>' +
      gorsel +
      (metinli ? '<div class="wpop__icerik"><div class="wpop__ic">' + ic + '</div></div>' : '') +
      '</div>';

    // Denetim (başarı hâline geçiş) dialog'a iliştirilir: önizleme ve doğrulama dönüşü kullanıyor
    d._wpop = bagla(d, p, f, sec);
    return d;
  }

  /* ── Davranış ─────────────────────────────────────────────────────── */
  const EPOSTA = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/;

  function bagla(d, p, f, sec) {
    let islem = false;     // tıkladı ya da kaydoldu: kapanış "kapatma" sayılmaz
    let basarili = false;
    let mesgul = false;    // kayıt sürüyor (hCaptcha / gönderim): perdeye tıklama kapatmasın
    let kapandi = false;
    const form = d.querySelector('.wpop__form');
    const buton = form ? form.querySelector('.wpop__buton') : null;
    const hataEl = form ? form.querySelector('.wpop__hata') : null;

    function kapat(neden) {
      if (sec.onizleme && ONIZLEME_CERCEVESI) return;   // yönetimdeki önizleme hep açık
      if (kapandi) return;
      kapandi = true;
      if (neden === 'kapat' && !islem && !sec.onizleme) olay(p, 'kapat');
      sahnedenKaldir(d);
    }

    d.querySelector('[data-wpop-kapat]').addEventListener('click', () => kapat('kapat'));

    d.querySelectorAll('[data-wpop-tikla]').forEach((a) => {
      a.addEventListener('click', (e) => {
        if (sec.onizleme) {
          e.preventDefault();
          return;
        }
        islem = true;
        olay(p, 'tikla');
      });
    });

    const tamam = d.querySelector('[data-wpop-tamam]');
    if (tamam) {
      tamam.addEventListener('click', () => {
        islem = true;
        if (!sec.onizleme) olay(p, 'tikla');
        kapat('tamam');
      });
    }

    const denetim = {
      kapat,
      perdeKapatir: () => !mesgul,
      basari() {},
    };
    if (!form) return denetim;

    function hata(metin) {
      hataEl.textContent = metin || '';
      hataEl.hidden = !metin;
    }

    let mesgulZaman = 0;
    function bekliyor(acik) {
      mesgul = acik;
      clearTimeout(mesgulZaman);
      if (acik) {
        buton.setAttribute('aria-busy', 'true');
        buton.disabled = true;
        // Doğrulama bulmacası kapatılırsa Shopify bize haber vermiyor: buton kilitli kalmasın
        mesgulZaman = setTimeout(() => bekliyor(false), 20000);
      } else {
        buton.removeAttribute('aria-busy');
        buton.disabled = false;
      }
    }

    function basariGoster(gercek) {
      if (basarili) return;
      basarili = true;
      islem = true;
      bekliyor(false);
      const alan = form.querySelector('.wpop__alan');
      const kutu = form.querySelector('.wpop__basari');
      // Formun yerini aynı yükseklikte doldur: pop-up zıplamasın
      if (alan.offsetHeight) kutu.style.minHeight = alan.offsetHeight + 'px';
      alan.hidden = true;
      kutu.hidden = false;
      buton.textContent = f.basari_buton || 'ALIŞVERİŞE DEVAM ET';
      if (gercek) {
        oturumKoy('bekleyen', null);
        koy('abone', '1');
        olay(p, 'kayit');
        if (f.indirim_kodu) {
          // Kodu sepete işle: Shopify /discount/<kod> çerezi ödeme adımında uygular
          fetch('/discount/' + encodeURIComponent(f.indirim_kodu), { credentials: 'same-origin' }).catch(() => {});
        }
      }
    }
    denetim.basari = basariGoster;

    function devam() {
      const h = guvenliLink(f.basari_link);
      if (h && !sec.onizleme) {
        location.href = h;
        return;
      }
      kapat('devam');
    }

    /* Gönderim. Önce sayfa yenilemeden denenir; Shopify'ın önündeki
       Cloudflare arka plan isteğini "bağlantınız doğrulanıyor" denetimine
       sokarsa (403, cf-mitigated) ya da sonuç anlaşılamazsa footer'daki
       E-BÜLTEN gibi SAYFA GEÇİŞİYLE gönderilir: tarayıcı denetimi geçer,
       Shopify ?customer_posted=true ile bu sayfaya döndürür, pop-up orada
       "kazandınız" hâliyle yeniden açılır (sessionStorage wpop:bekleyen).
       hCaptcha anahtarı (h-captcha-response) iki yolda da formun içinde. */
    async function gonder() {
      if (sec.onizleme) {
        basariGoster(false);
        return;
      }
      const govde = new URLSearchParams();
      new FormData(form).forEach((v, k) => govde.append(k, v));
      try {
        const r = await fetch('/contact', { method: 'POST', body: govde, credentials: 'same-origin' });
        if (/[?&]customer_posted=true/.test(r.url)) {
          basariGoster(true);
          return;
        }
        if (r.ok && !r.headers.get('cf-mitigated') && !/\/challenge/.test(r.url)) {
          const doc = new DOMParser().parseFromString(await r.text(), 'text/html');
          if (doc.querySelector('.mf__form-ok')) {
            basariGoster(true);
            return;
          }
          const msg = doc.querySelector('.mf__form-error');
          if (msg && msg.textContent.trim()) {
            hata(msg.textContent.trim());
            bekliyor(false);
            return;
          }
        }
      } catch (err) { /* ağ hatası: sayfa geçişiyle dene */ }
      oturumKoy('bekleyen', p.id);
      HTMLFormElement.prototype.submit.call(form);
    }

    /* Shopify'ın hCaptcha'sı forma bağlanırken o anki submit()'i "asıl
       gönderim" diye saklıyor ve doğrulama bitince onu çağırıyor (anahtarı
       forma ekledikten sonra). Bağlanmadan önce kendi gönderimimizi koyuyoruz. */
    form.submit = function () { gonder(); };

    form.addEventListener('change', (e) => {
      if (e.target.hasAttribute('data-wpop-onay')) e.target.closest('.wpop__onay').classList.remove('is-zorunlu');
      hata('');
    });

    const kopyala = d.querySelector('[data-wpop-kopyala]');
    if (kopyala) {
      kopyala.addEventListener('click', () => {
        const yaz = () => { kopyala.textContent = 'KOPYALANDI'; };
        if (navigator.clipboard) navigator.clipboard.writeText(f.indirim_kodu).then(yaz, () => {});
      });
    }

    /* Bu dinleyici formun ÜZERİNDE, Shopify'ınkilerden önce çalışır:
       geçersizse olayı tamamen durdurur (hCaptcha boşuna çalışmasın),
       geçerliyse etiketleri yazıp akışı Shopify'ın korumasına bırakır. */
    form.addEventListener('submit', (e) => {
      const durdur = () => {
        e.preventDefault();
        e.stopImmediatePropagation();
      };
      if (basarili) {
        durdur();
        devam();
        return;
      }
      if (mesgul) {
        durdur();
        return;
      }
      hata('');
      const giris = form.elements['contact[email]'];
      const eposta = giris.value.trim();
      const secili = form.querySelector('.wpop__secenek input:checked');
      const onay = form.querySelector('[data-wpop-onay]');

      if (f.secenek_zorunlu && form.querySelector('.wpop__secenek') && !secili) {
        durdur();
        hata('Lütfen bir seçim yapın.');
        return;
      }
      if (!EPOSTA.test(eposta)) {
        durdur();
        hata('Lütfen geçerli bir e-posta adresi girin.');
        giris.focus();
        return;
      }
      if (onay && f.onay_zorunlu && !onay.checked) {
        durdur();
        onay.closest('.wpop__onay').classList.add('is-zorunlu');
        onay.focus();
        return;
      }

      giris.value = eposta;
      const etiketler = (f.etiketler || []).slice();
      if (secili) {
        const s = (f.secenekler || [])[+secili.value];
        if (s && s.etiket) etiketler.push(s.etiket);
      }
      form.elements['contact[tags]'].value = etiketler.join(', ');
      bekliyor(true);

      const koruma = window.Shopify && window.Shopify.captcha;
      if (sec.onizleme || !koruma || typeof koruma.protect !== 'function') {
        durdur();                       // önizleme ya da mağazada koruma yok
        gonder();
        return;
      }
      if (form.hasAttribute('data-hcaptcha-bound')) {
        // Koruma bağlı (kutuya tıklanınca bağlanır): Shopify'ın dinleyicisi
        // doğrular, sonra form.submit() → gonder()
        e.preventDefault();
        return;
      }
      // Henüz bağlanmamış (kutuya odaklanmadan gönderildi): bağla, sonra doğrula
      durdur();
      try {
        koruma.protect(form, () => form.submit());
      } catch (err) {
        gonder();
      }
    });

    return denetim;
  }

  /* ── Kurallar ─────────────────────────────────────────────────────── */
  function yolUyar(yol, kalip) {
    let k = String(kalip || '').toLowerCase().trim();
    if (!k) return false;
    if (k.slice(-1) === '*') return yol.indexOf(k.slice(0, -1)) === 0;
    k = k.replace(/\/+$/, '') || '/';
    if (k === '/') return yol === '/';
    return yol === k || yol.indexOf(k + '/') === 0;
  }

  function uygun(p, veri) {
    const k = p.kurallar || {};
    const t = Date.now();
    if (k.bas && t < k.bas) return false;
    if (k.bit && t > k.bit) return false;
    if (k.kimler === 'misafir' && B.musteri) return false;
    if (k.abone_gizle && al('abone')) return false;
    const m = mobil();
    if (k.cihaz === 'mobil' && !m) return false;
    if (k.cihaz === 'masaustu' && m) return false;
    if (k.sayfalar === 'secili' && (k.sayfa_turleri || []).indexOf(B.sayfa) === -1) return false;
    const yol = decodeURI(location.pathname).toLowerCase();
    if ((k.haric_yollar || []).some((y) => yolUyar(yol, y))) return false;
    if ((k.dahil_yollar || []).length && !k.dahil_yollar.some((y) => yolUyar(yol, y))) return false;
    if (veri.ayar && veri.ayar.oturum_tek && oturumAl('goruldu')) return false;

    const son = +al('g' + p.id) || 0;
    switch (k.siklik) {
      case 'her':
        return true;
      case 'oturum':
        return !oturumAl('g' + p.id);
      case 'bir_kez':
        return !son;
      default:
        return !son || t - son >= (+k.saat || 24) * 3600000;
    }
  }

  function tetikle(p, ac) {
    const k = p.kurallar || {};
    let oldu = false;
    let zaman = 0;

    function bir() {
      if (oldu) return;
      oldu = true;
      clearTimeout(zaman);
      document.removeEventListener('scroll', kaydir, true);
      document.removeEventListener('mouseout', cikis);
      ac();
    }

    function kaydir(e) {
      const el = e.target && e.target.nodeType === 1 ? e.target : document.scrollingElement;
      // Yalnız sayfanın kendi kaydırması (geniş ekranda .page-wrapper), iç listeler değil
      if (el !== document.scrollingElement && !(el.classList && el.classList.contains('page-wrapper'))) return;
      const enCok = el.scrollHeight - el.clientHeight;
      if (enCok > 0 && (el.scrollTop / enCok) * 100 >= (+k.kaydirma || 40)) bir();
    }

    function cikis(e) {
      if (!e.relatedTarget && e.clientY <= 0) bir();
    }

    if (k.tetik === 'kaydirma') {
      document.addEventListener('scroll', kaydir, { capture: true, passive: true });
    } else if (k.tetik === 'cikis' && window.matchMedia('(hover: hover) and (pointer: fine)').matches) {
      document.addEventListener('mouseout', cikis);
    } else {
      // "Sayfadan çıkarken" telefonda yok — süreye düşer
      zaman = setTimeout(bir, Math.max(0, k.sure == null ? 3 : +k.sure) * 1000);
    }
  }

  /* ── Açma ─────────────────────────────────────────────────────────── */
  let acik = false;

  /* Pencere MODAL AÇILMIYOR (showModal yok). Modal pencere tarayıcının en üst
     katmanına çıkar ve sayfanın geri kalanını tıklanamaz yapar; Shopify'ın
     hCaptcha doğrulama bulmacası sayfa gövdesine (z-index 2147483647) eklendiği
     için pop-up'ın ARKASINDA kalıp çözülemezdi (2026-11-03'te görüldü).
     Bunun yerine: kendi perdemiz + pencere (z-index bulmacanın bir kat altında)
     + sayfa `inert` (fare/klavye arkaya geçmez) + Esc + kaydırma kilidi.
     Odak pencerenin kendisinde başlar: × düğmesinde odak çerçevesi görünmez,
     telefonda klavye kendiliğinden açılmaz; Tab ile × düğmesine geçilir. */
  function sahneyeKoy(d, p, sec) {
    const g = p.gorunum || {};
    const perdeEl = document.createElement('div');
    perdeEl.className = 'wpop-perde' + (sec.aninda ? ' wpop-perde--aninda' : '');
    perdeEl.style.background = 'rgba(0,0,0,' +
      (Math.max(0, Math.min(95, +(g.perde == null ? 60 : g.perde))) / 100) + ')';
    perdeEl.setAttribute('aria-hidden', 'true');
    if (sec.aninda) d.classList.add('wpop--aninda');
    d.setAttribute('aria-modal', 'true');
    document.body.appendChild(perdeEl);
    document.body.appendChild(d);
    d.setAttribute('open', '');
    d._perde = perdeEl;
    perdeEl.addEventListener('click', () => {
      if (d._wpop.perdeKapatir()) d._wpop.kapat('kapat');
    });
    if (sec.onizleme && ONIZLEME_CERCEVESI) return;   // yönetimdeki önizleme: odak düzenleyicide kalsın

    const sayfa = document.querySelector('.page-wrapper');
    if (sayfa && !sayfa.inert) {
      sayfa.inert = true;
      d._inert = sayfa;
    }
    d._esc = (e) => {
      if (e.key === 'Escape' && d._wpop.perdeKapatir()) d._wpop.kapat('kapat');
    };
    document.addEventListener('keydown', d._esc);
    document.documentElement.classList.add('wpop-kilit');
    try {
      d.focus({ preventScroll: true });
    } catch (e) { /* eski tarayıcı */ }
  }

  function sahnedenKaldir(d) {
    if (d._esc) document.removeEventListener('keydown', d._esc);
    if (d._inert) d._inert.inert = false;
    document.documentElement.classList.remove('wpop-kilit');
    if (d._perde) d._perde.remove();
    d.removeAttribute('open');
    d.remove();
    acik = false;
  }

  function cssHazir() {
    if (!B.css || document.querySelector('link[data-wpop-css]')) return Promise.resolve();
    return new Promise((coz) => {
      const l = document.createElement('link');
      l.rel = 'stylesheet';
      l.href = B.css;
      l.setAttribute('data-wpop-css', '');
      l.onload = coz;
      l.onerror = coz;
      document.head.appendChild(l);
      setTimeout(coz, 4000);
    });
  }

  /* "300" Heavy ve "İNDİRİM" Light sayfada başka yerde kullanılmıyor; inmeden
     açılırsa bir an yedek yazı tipiyle görünür. En çok 1,5 sn beklenir. */
  function yaziHazir() {
    if (!document.fonts || !document.fonts.load) return Promise.resolve();
    const yukle = ['800 40px Maraton', '300 40px Maraton', '700 16px Maraton', '400 16px Maraton']
      .map((y) => document.fonts.load(y).catch(() => {}));
    return Promise.race([Promise.all(yukle), bekle(1500)]);
  }

  /* Sepet, ölçü tablosu gibi başka bir pencere açıksa onun kapanmasını,
     sekme arka plandaysa öne gelmesini bekle — görülmeyen gösterim sayılmasın */
  async function sahneBos() {
    for (let i = 0; i < 400; i++) {
      const baska = document.querySelector('dialog[open]:not(.wpop)');
      if (!baska && document.visibilityState !== 'hidden') return true;
      await bekle(1500);
    }
    return false;
  }

  async function ac(p, sec) {
    sec = sec || {};
    if (acik) return null;
    acik = true;
    if (!sec.onizleme && !sec.donus && !(await sahneBos())) {
      acik = false;
      return null;
    }
    await Promise.all([cssHazir(), yaziHazir()]);
    const d = ciz(p, sec);
    sahneyeKoy(d, p, sec);

    if (!sec.onizleme) {
      koy('g' + p.id, Date.now());
      oturumKoy('goruldu', '1');
      oturumKoy('g' + p.id, '1');
      if (!sec.donus) olay(p, 'gosterim');
    }
    return d;
  }

  /* ── Başlangıç ────────────────────────────────────────────────────── */
  function veriOku() {
    const el = document.getElementById('workuid-popup-veri');
    if (!el) return { popups: [] };
    try {
      const v = JSON.parse(el.textContent);
      return v && Array.isArray(v.popups) ? v : { popups: [] };
    } catch (e) {
      return { popups: [] };
    }
  }

  async function sitedeDene(id, anahtar) {
    if (!B.proxy) return;
    try {
      const r = await fetch(B.proxy + '/onizle?id=' + encodeURIComponent(id) + '&t=' + encodeURIComponent(anahtar),
        { credentials: 'same-origin', cache: 'no-store' });
      const j = await r.json();
      if (j && j.popup) await ac(j.popup, { onizleme: true });
      else console.warn('[Workuid Pop-up]', (j && j.error) || 'Önizleme açılamadı.');
    } catch (e) {
      console.warn('[Workuid Pop-up] Önizleme açılamadı.', e);
    }
  }

  function baslat() {
    const veri = veriOku();
    const posted = /[?&]customer_posted=true/.test(location.search);

    // Footer'daki E-BÜLTEN'den kayıt olan da "abone" sayılır
    if (posted) koy('abone', '1');

    // Sayfa geçişiyle gönderilen kayıttan dönüş (Cloudflare/hCaptcha doğrulaması
    // sonrası Shopify ?customer_posted=true ile döndürür): pop-up beklemeden,
    // canlandırmasız "kazandınız" hâliyle açılır — ziyaretçi için butona
    // bastığı pencere kaldığı yerden devam ediyor gibi
    const bekleyen = oturumAl('bekleyen');
    if (bekleyen) {
      oturumKoy('bekleyen', null);
      const p = posted && veri.popups.find((x) => String(x.id) === String(bekleyen));
      if (p) {
        ac(p, { donus: true, aninda: true }).then((d) => {
          if (d && d._wpop) d._wpop.basari(true);
        });
        return;
      }
    }

    // "Sitede dene" (yönetim ekranı): #wpopup=<kimlik>.<anahtar>
    const m = location.hash.match(/[#&]wpopup=(\d+)\.([\w.-]+)/);
    if (m) {
      sitedeDene(m[1], m[2]);
      return;
    }

    const aday = veri.popups.find((p) => uygun(p, veri));
    if (aday) tetikle(aday, () => ac(aday));
  }

  window.WorkuidPopup = {
    surum: 1,
    ciz,
    ac,
    /* Yönetim ekranındaki önizleme: kuralsız, anında, sayaçsız. Odak
       çerçeveye ALINMIYOR — düzenleyicide yazarken her harfte imleç kaçardı. */
    onizle(p, secenek) {
      secenek = secenek || {};
      document.querySelectorAll('dialog.wpop, .wpop-perde').forEach((x) => x.remove());
      acik = false;
      const d = ciz(p, { onizleme: true });
      sahneyeKoy(d, p, { onizleme: true, aninda: true });
      if (secenek.basari && d._wpop) d._wpop.basari(false);
      return d;
    },
  };

  if (!ONIZLEME_CERCEVESI) {
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', baslat);
    else baslat();
  }
})();
